// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.youCPagYZ1i2OQGHjbSg {
    align-items: center;
    color: #ffffff;
    display: flex;
    gap: 15px;
    font-size: 14px;
    justify-content: center;
    line-height: 1.2;
    max-width: 350px;
    text-align: left;
}

.J918_DDWegvsulhEgZ4K {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid var(--red);
}

.YmoXBk4aO4S4JpCNpr_r {
    background: var(--blue);
    border-radius: 50%;
    background-size: cover;
    height: 35px;
    line-height: 35px;
    text-align: center;
    width: 35px;
}
.SqD_Yt9CE4rNH7ZLbGX0 {
    color: black;
}

@media screen and (max-width: 767px) {
    .youCPagYZ1i2OQGHjbSg {
        gap: 5px;
    }

    .youCPagYZ1i2OQGHjbSg.LsxIQ_8L8ClFbXdpyt_A div {
        font-size: 10px;
    }

    .J918_DDWegvsulhEgZ4K {
        width: 27px;
        height: 27px;
    }
    .SqD_Yt9CE4rNH7ZLbGX0 {
        font-size: 12px;
        max-width: 180px;
        height: 32px;
        overflow: hidden;
    }
    .YmoXBk4aO4S4JpCNpr_r {
        background: var(--blue);
        height: 26px;
        line-height: 26px;
        width: 26px;
        font-size: 10px;
    }
}

@media screen and (max-width: 470px) {
    .youCPagYZ1i2OQGHjbSg.LsxIQ_8L8ClFbXdpyt_A {
        max-width: min-content;
    }
    .youCPagYZ1i2OQGHjbSg {
        gap: 15px;
        margin-right: 12px;
    }
    .SqD_Yt9CE4rNH7ZLbGX0 {
        display: none;
    }
    
}
.youCPagYZ1i2OQGHjbSg img {
    transition: all 0.3s ease-in-out;
}
.bmFJ0T_o9lbKsT0CiWpA {
    transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/styles/Profile.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,uBAAuB;QACvB,YAAY;QACZ,iBAAiB;QACjB,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;;AAEJ;AACA;IACI,gCAAgC;AACpC;AACA;IACI,wBAAwB;AAC5B","sourcesContent":[".user {\n    align-items: center;\n    color: #ffffff;\n    display: flex;\n    gap: 15px;\n    font-size: 14px;\n    justify-content: center;\n    line-height: 1.2;\n    max-width: 350px;\n    text-align: left;\n}\n\n.userAvatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 1px solid var(--red);\n}\n\n.avatar {\n    background: var(--blue);\n    border-radius: 50%;\n    background-size: cover;\n    height: 35px;\n    line-height: 35px;\n    text-align: center;\n    width: 35px;\n}\n.username {\n    color: black;\n}\n\n@media screen and (max-width: 767px) {\n    .user {\n        gap: 5px;\n    }\n\n    .user.ite div {\n        font-size: 10px;\n    }\n\n    .userAvatar {\n        width: 27px;\n        height: 27px;\n    }\n    .username {\n        font-size: 12px;\n        max-width: 180px;\n        height: 32px;\n        overflow: hidden;\n    }\n    .avatar {\n        background: var(--blue);\n        height: 26px;\n        line-height: 26px;\n        width: 26px;\n        font-size: 10px;\n    }\n}\n\n@media screen and (max-width: 470px) {\n    .user.ite {\n        max-width: min-content;\n    }\n    .user {\n        gap: 15px;\n        margin-right: 12px;\n    }\n    .username {\n        display: none;\n    }\n    \n}\n.user img {\n    transition: all 0.3s ease-in-out;\n}\n.arrow_down {\n    transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user": `youCPagYZ1i2OQGHjbSg`,
	"userAvatar": `J918_DDWegvsulhEgZ4K`,
	"avatar": `YmoXBk4aO4S4JpCNpr_r`,
	"username": `SqD_Yt9CE4rNH7ZLbGX0`,
	"ite": `LsxIQ_8L8ClFbXdpyt_A`,
	"arrow_down": `bmFJ0T_o9lbKsT0CiWpA`
};
export default ___CSS_LOADER_EXPORT___;
